export const GET_PAYMENT_PROFILES = 'FINANCE/GET_PAYMENT_PROFILES'

export const GET_PAYMENT_PROFILE_BY_ID = 'FINANCE/GET_PAYMENT_PROFILE_BY_ID'

export const SET_PAYMENT_PROFILES_DATA = 'FINANCE/SET_PAYMENT_PROFILES_DATA'
export const SET_PAYMENT_PROFILE_DATA = 'FINANCE/SET_PAYMENT_PROFILE_DATA'

export const RESET_PAYMENT_PROFILE_DATA = 'FINANCE/RESET_PAYMENT_PROFILE_DATA'
export const SET_PAYMENT_PROFILES_FILTER = 'FINANCE/SET_PAYMENT_PROFILES_FILTER'
export const RESET_PAYMENT_PROFILES_DATA = 'FINANCE/RESET_PAYMENT_PROFILES_DATA'
export const CREATE_PAYMENT_PROFILE = 'FINANCE/CREATE_PAYMENT_PROFILE'
export const GET_ORGANIZATION_SUGGEST = 'FINANCE/GET_ORGANIZATION_SUGGEST'
export const GET_ORGANIZATION_BANK = 'FINANCE/GET_ORGANIZATION_BANK'
export const DROP_PAYMENT_PROFILES_DATA = 'FINANCE/DROP_PAYMENT_PROFILES_DATA'
